module.exports = __webpack_public_path__ + "static/firstSectionTertiaryImage1-5e1dfeeca8b0611b9f374829dde02b0c.jpeg";